import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperNavigationInterface, SwiperAutoplayInterface } from 'ngx-swiper-wrapper';
import { OvsComponent, DisplaySize, DisplayServiceBase  } from '../../shared/core/ovs.core';
import { ResortDetail, ResortImageFormat, ResortImageType, ResortImage } from '../../models/presentation.model';
import { ResortApplicationBase } from '../../services/resort-application.service';
import { ResortComponent } from '../../shared/resort.component';
import { ResortDetailsPageEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
  selector: 'resort-hero-gallery',
  templateUrl: './resort-hero-gallery.component.html',
  styleUrls: ['./resort-hero-gallery.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResortHeroGalleryComponent extends ResortComponent implements AfterViewInit
{
    private _swiper: any;
    @ViewChild("swiper")
    private _swiperElementRef: ElementRef;
  	private _display: DisplayServiceBase;
    public get partnerName(): string {
        return this.configuration.Partner.LongName;
    }

    @Input()
    public resort: ResortDetail;
    public displaySize: DisplaySize = DisplaySize.None;
    public images: ResortImage[] = [];
    public displayImages: ResortImage[] = []; //filterd by display size
    public showButtons: boolean = true;
    @Input()
    public imageTypes: ResortImageType[]=[];

	constructor(display: DisplayServiceBase)
    {
        super();
		this._display = display;
    }

    protected initialize(): void
    {
        super.initialize();
        if(this.resort.isPreferred) {
            this.images = this.getImagesByType(this.resort.resortImageList, [ResortImageType.Hero]);
        }
        else {
            let heroimges = this.resort.resortImageList.where(i => i.fileName.substr(4, 1) != 'F' && i.imageType != ResortImageType.Search).toArray();

            if (heroimges !== null && heroimges.length === 0)
                this.images = this.resort.resortImageList.where(i => i.fileName.substr(4, 1) != 'F').toArray();
            else
                this.images = this.getImagesByType(heroimges, this.imageTypes);
        }
        this.images.orderBy(i => i.imageFormat == ResortImageFormat.Video ? 1 : i.imageFormat == ResortImageFormat.EmbeddedVideo ? 2 : 3)
        .toArray();
        this.subscribe(this._display.displaySize, (r) => this.onDisplaySizeChanged(r));
        this.setDisplaySizeImages();

    }

	private onDisplaySizeChanged(size: DisplaySize): void {
		this.displaySize = size;
		this.setDisplaySizeImages();
	}
	setDisplaySizeImages(){
		switch (this.displaySize) {
			case DisplaySize.Medium:
			case DisplaySize.Small:
			case DisplaySize.ExtraSmall:
				this.filterOutVideoImages();
				break;
			default:
				this.displayImages = this.images;
				break;
		}
	}
	public filterOutVideoImages() {
		this.displayImages = this.images.filter((image: ResortImage) => {
			return (image.imageFormat !== ResortImageFormat.EmbeddedVideo &&
				image.imageFormat !== ResortImageFormat.Video);
		});
	}
    public ngAfterViewInit(): void
    {
        let element: any = this._swiperElementRef.nativeElement;
        const swipeConfig: SwiperConfigInterface = {
            direction: 'horizontal',
            loop: false,
            autoplay: false,
            navigation: {
                nextEl: '.hero-swiper__btn--next',
                prevEl: '.hero-swiper__btn--prev',
            },
        };
        this._swiper = new Swiper(element, swipeConfig);
    }

    public swipe():void{
        UserActivityLogger.logEvent(ResortDetailsPageEvents.ResortHeroArrowClicked, {}, UserActivityLoggerOptions.AppInsightsOnly);
    }

    public vidoeClick():void{
        UserActivityLogger.logEvent(ResortDetailsPageEvents.WatchedVideo, {}, UserActivityLoggerOptions.AppInsightsOnly);
    }

    public slideTo(index): void {
      this._swiper.slideTo(index += 1);
      console.log(`IMAGE INDEX: ${index}`);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-hero-gallery/resort-hero-gallery.component.ts